import {scrollTo} from "@/functions/scrollTo";
import Vue from "vue";
import Router from "vue-router";
import dashboardRoutes from "./constants/dashboardRoutes";

Vue.use(Router);
let routes = dashboardRoutes;

if (false) { // window.slugDashboardRoutes
	routes = [
		{
			path: "/:tenant",
			component: {
				template: "<router-view />",
			},
			children: dashboardRoutes.map(route => {
				if (!route.path) {
					return route;
				}
				route.path = route.path.replace(/^\/+/g, "");
				return route;
			}),
		},
	];
}

const portalRouter = new Router({
	mode: "history",
	routes: routes,
});

portalRouter.beforeEach((to, from, next) => {
	scrollTo(0, {
		context: "[role=main]",
	});
	window.app.$vmodal?.close();
	window.app.$store?.commit("errorsStore/RESET");
	next();
});

portalRouter.afterEach((to, from, next) => {
	window.app.$store?.commit("authStore/SET_JUST_LOGGED_IN", from.meta.setJustLoggedIn || false);
});

export default portalRouter;
